import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import './ForgetEmailView.less';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import BrandButton from '../../components/BrandButton/BrandButton';
import { GA_TITLES } from '../../../utils';
import { PhoneItem } from './types';
import {
  isLocalizeAdded,
  LocalizePropType,
  PhoneCode,
} from 'getaway-data-layer';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type Props = {
  localize: LocalizePropType;
  phoneNumber: PhoneItem;
  onSubmit: () => void;
  onClose: () => void;
  isValidNumber: () => void;
  phoneCodes: Array<PhoneCode>;
  onPhoneNumberChanged: (value: string, data: any) => void;
  turnstileRef: any;
};

const ForgetEmailView = ({
  localize,
  phoneNumber,
  isValidNumber,
  phoneCodes,
  onPhoneNumberChanged,
  onSubmit,
  onClose,
  turnstileRef,
}: Props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="ForgetEmailView-title"
        DescriptionTestId="ForgetEmailView-description"
        title={localize('forget.email.title')}
        description={localize('forget.email.desc')}
        showHelp
        showArrowBack
        onClose={onClose}
      />
      <div
        className={
          isLocalizeAdded(localize, 'phone.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'phone.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          <form style={{ width: '100%' }}>
            <PhoneInput
              country="de"
              specialLabel={localize('phone.verify.mobile.phone.text')}
              onlyCountries={phoneCodes?.map((phoneCode) =>
                phoneCode?.country?.toLowerCase()
              )}
              value={phoneNumber.value}
              isValid={() => !phoneNumber.error}
              onBlur={isValidNumber}
              onChange={onPhoneNumberChanged}
              inputClass="forget-email-input"
              inputProps={{
                'data-testid': 'ForgetEmailView-addPhone',
                id: 'number',
                name: 'phone',
                required: true,
                autoComplete: 'tel',
              }}
            />
            <p className="forget-email-error noselect">{phoneNumber.error}</p>
          </form>
          <div ref={turnstileRef} className="turnstile-widget" />
          <BrandButton
            id={GA_TITLES.ON_BOARDING.ADD_PHONE}
            title={localize('phone.verify.send.code')}
            onClick={onSubmit}
          />
        </div>
      </div>
      {isLocalizeAdded(localize, 'phone.faq') && (
        <div className="faq">
          <Markdown rehypePlugins={[rehypeRaw]}>
            {localize('phone.faq')}
          </Markdown>
        </div>
      )}
    </div>
  );
};

export default ForgetEmailView;
